<template>
    <el-breadcrumb class="app-levelbar" separator="/">
        <a href="/gjgzhjy/#/mainPage"><span class="remind" style="float:left" @mouseover="mouseover" @mouseout="mouseout">您有 {{unReadNumber}} 条未读信息</span></a>
    </el-breadcrumb>
</template>

<script>
import UnreadMessage from '../../utils/unreadMessage.js';

export default {
    data() {
        return {
            unReadNumber: 0,
            tableLoading: null,
        }
    },
    created() {
        this.getUnReadNumber();
    },
    mounted(){
        var that = this;
        UnreadMessage.$on('demo',function(msg){
            //console.log(msg);
            that.getUnReadNumber();
        })
    },
    methods: {
        getUnReadNumber(){
            const paramMap = {
                'name': 'combo_Info'
            }
            this.tableLoading = true;
            this.$api.message.message.getUnReadNumber({
                data: paramMap
            }).then(response => {
                this.unReadNumber = response.data.data.unReadNumber;
                this.tableLoading = false;
            }).catch(error => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        mouseover(){
            $('.remind').css('color','#55aaff');
        },
        mouseout(){
            $('.remind').css('color','#606266');
        },
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-levelbar.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .no-redirect {
        color: #97a8be;
        cursor: text;
    }
}
.remind{
    color: #606266;
}
</style>



// WEBPACK FOOTER //
// messageRemind.vue?76cba9fb